// removed by extract-text-webpack-plugin
module.exports = {"title":"src-components----NavBar-module---title---2URWo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar.module.css
// module id = 392
// module chunks = 79611799117203